import React from "react";
import StickyNavbar from "../navbar";
import { Link } from "react-router-dom";
import * as motion from "motion/react-client";

const chapter7 = () => {
  return (
    <div>
      <StickyNavbar />
      <div className="bg-white text-black p-4 lg:mt-10 mt-20 text-2xl sm:p-10 lg:px-20">
        <div className="text-center mb-8">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold">
            Chapter 7: Dissemination and Community Engagement
          </h1>
        </div>
        <motion.div
                   className="mt-6 flex items-center justify-center m-auto "
                   initial={{ opacity: 0, scale: 0.9 }}
                   animate={{ opacity: 1, scale: 1 }}
                   transition={{ duration: 0.8 }}
                 >
                   <iframe
                     width="65%"
                     height="630"
                     src="https://res.cloudinary.com/dpz8hsb33/video/upload/v1740857488/Chapter6_research_dissemination_and_community_engagement_fyy0ny.mp4"
                     title="Introduction to Research"
                     frameBorder="0"
                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                     allowFullScreen
                     className="rounded-lg"
                   ></iframe>
                 </motion.div>
        <div className="space-y-8 text-lg mt-5 md:mt-10">
          <div>
            <p>
              The Community Health Extension Worker (WHO) will share their
              research findings (WHAT) with the community, colleagues, and other
              key people such as local leaders and government officials (WITH
              WHOM). They will do this by holding dissemination events such as
              community meetings or carrying out short presentations (HOW) to
              make sure the information is clear and useful to others. This will
              happen in the community or other relevant places, like healthcare
              facilities or local government offices (WHERE), after the research
              is complete (WHEN).
            </p>
          </div>
          <ul className="list-disc list-inside space-y-3">
            <li>Dissemination has to be a team effort.</li>
            <li>
              Joint projects – research projects between two facilities – when
              engaging the community. Some facilities may not be big enough to
              lead project on their own - so can collaborate between different
              facilities.
            </li>
            <li>Facilities led by CHO’s.</li>
            <li>
              Head of facility – CHO has to be on board with everything for the
              whole project/start to finish.
            </li>
            <li>
              When disseminating findings you can also do it as a joint project.
            </li>
            <li>Writing up findings – how to do references.</li>
          </ul>
          <div>
            <p>
              When you have completed your research, the next step is for you to
              share what you found and what you have learned. This process is
              called <span className=" font-bold text-[#005FFF]">dissemination</span>. Dissemination is important because we do
              research not just to collect information, but so that it can
              benefit the community in some way. In order for the research to
              benefit others, they must first know about it. This chapter will
              guide you what dissemination of your research is, and who to
              involve in the process.(93-97)
            </p>
          </div>
          <div className="flex justify-between mt-10">
            <Link to="/chapter6">
              <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                Previous
              </button>
            </Link>
            <Link to="/chapter7/sectionTwo">
              <button className="bg-blue-900 text-white px-6 py-2 rounded-lg hover:bg-blue-700">
                Next
              </button>
            </Link>
            
          </div>
        </div>
      </div>
    </div>
  );
};
export default chapter7;
